import { useTranslation } from '@mint-lib/i18n';
import { AiStarGradient } from '@mint-lib/icons';
import { useFlags } from '@mint-lib/routing-context';
import { Button, typographyVariants } from '@mint-lib/tw-components';
import type { Suggestions } from '@mint-sdk/api-recommendations';

import WidgetCarousel from '../WidgetCarousel/WidgetCarousel.jsx';

type KpiWidgetProps = {
  suggestion: Suggestions.SuggestionResponseType;
  toggleAiChat?: () => void;
};

const KpiWidget = ({ suggestion, toggleAiChat }: KpiWidgetProps) => {
  const ff = useFlags('@mint/arm', ['aiSidebar', 'agenticMetadata']);
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-center gap-2">
        <p className={typographyVariants({ variant: 'h4' })}>
          {t('Forecasted KPIs')}
        </p>
        {ff.aiSidebar.enabled && !ff.agenticMetadata.enabled ? (
          <Button
            className="border-ai-lightGreen"
            variant="outlined"
            size="small"
            onClick={() => toggleAiChat?.()}
          >
            <AiStarGradient className="size-5 fill-icon-primary" />
            {t('AI assistant')}
          </Button>
        ) : null}
      </div>
      <WidgetCarousel suggestion={suggestion} />
    </div>
  );
};

export default KpiWidget;
